$(function () {
  if (!customElements.get('product-sticky-form')) {
    customElements.define(
      'product-sticky-form',
      class productDetailsSticky extends HTMLElement {
        constructor() {
          super();
          this.$productInfo = null;
          this.$myThumbs = null;
          this.$myThumbsPackage = null;
          this.$myThumbsVideo = null;
          this.$myGallery = null;
          this.$myGalleryVideo = null;
          this.$myGalleryPackage = null;
          this.$galleryThumbsSwiper = null;
          this.$galleryPackageThumbsSwiper = null;
          this.$galleryMainSwiper = null;
          this.$galleryVideoMainSwiper = null;
          this.$galleryPackageMainSwiper = null;
          this.$galleryVideoThumbsSwiper = null;
          this.$thumbsImage = null;
          this.$thumbsVideo = null;
          this.$thumbsPackage = null;
          this.thumbsSwiper = null;
          this.mainSwiper = null;
          this.currentIndex = 0;
          this.$productMedia = null;
          this.imagesArray = [];
        }

        connectedCallback() {
          try {
            // 初始化所有元素
            this.initElements();

            // 检查必要元素是否存在
            if (!this.$myGallery || !this.$myThumbsPackage) {
              console.warn('Some required elements are missing');
              return;
            }

            // 获取并解析图片数据
            this.imagesArray = this.getImagesArray();

            // 按顺序初始化其他功能
            this.swiperInit();
            this.productInfoFunction();
            this.galleryThumbs();
            this.mainGallery();
            this.mainGalleryVideo();
            this.positionListener();
            this.changeGallery();
            this.observeHeader();
            this.observeScroll();

            // 最后初始化 package gallery
            if (this.$myGalleryPackage) {
              this.mainGalleryPackage();
            }
          } catch (error) {
            console.error('Error in connectedCallback:', error);
          }
        }

        // 添加 initElements 方法
        initElements() {
          this.$thumbsImage = this.querySelectorAll('.thumbs-image');
          this.$thumbsVideo = this.querySelectorAll('.thumbs-video');
          this.$thumbsPackage = this.querySelectorAll('.thumbs-package');
          this.$productInfo = this.querySelector('#product-info');
          this.$myThumbs = this.querySelector('.myThumbs');
          this.$myThumbsPackage = this.querySelector('.myThumbsPackage');
          this.$myThumbsVideo = this.querySelector('.myThumbsVideo');
          this.$myGallery = this.querySelector('.myGallery');
          this.$myGalleryPackage = this.querySelector('.myGalleryPackage');
          this.$myGalleryVideo = this.querySelector('.myGalleryVideo');
          this.$productMedia = this.querySelector('.product-media');
        }

        observeHeader() {
          const header = document.querySelector('lt-header');
          if (!header) return;

          const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
              if (mutation.type === 'attributes' && mutation.attributeName === 'data-scrollshow') {
                const isScrollShow = header.getAttribute('data-scrollshow') === 'true';
                this.handleHeaderStateChange(isScrollShow);
              }
            });
          });

          observer.observe(header, {
            attributes: true,
            attributeFilter: ['data-scrollshow'],
          });
        }

        handleHeaderStateChange(isScrollShow) {
          const productImageSticky = this.querySelector('.product-image-sticky');
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

          if (!productImageSticky) return;

          productImageSticky.style.transition = 'margin-top 0.3s ease';

          if (isScrollShow && scrollTop > 0) {
            // productImageSticky.style.marginTop = '100px';
          } else {
            productImageSticky.style.marginTop = '';
          }
        }

        observeScroll() {
          window.addEventListener('scroll', () => {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            if (scrollTop === 0) {
              const productImageSticky = this.querySelector('.product-image-sticky');
              if (productImageSticky) {
                productImageSticky.style.marginTop = '';
              }
            }
          });
        }

        disconnectedCallback() {
          if (this.$galleryMainSwiper) {
            this.$galleryMainSwiper.destroy(true, true);
          }
          if (this.$galleryVideoMainSwiper) {
            this.$galleryVideoMainSwiper.destroy(true, true);
          }
          if (this.thumbsSwiper) {
            this.thumbsSwiper.destroy();
          }
          if (this.mainSwiper) {
            this.mainSwiper.destroy();
          }
          if (this.headerObserver) {
            this.headerObserver.disconnect();
          }
          window.removeEventListener('scroll', this.observeScroll);
        }
        swiperInit() {
          this.$thumbsImage.forEach((img) => img.classList.add('flex'));
          this.$thumbsVideo.forEach((video) => video.classList.add('hidden'));
          this.$thumbsPackage.forEach((packages) => packages.classList.add('hidden'));
        }
        positionListener() {
          window.addEventListener('current_positionChange', (event) => {
            const current_position = event.detail.current_position;
            this.$galleryMainSwiper.slideTo(Number(current_position));
          });
        }

        productInfoFunction() {
          const view = this.$productInfo.querySelector('#view');
          const arrow = this.$productInfo.querySelector('.arrow');
          const productContent = this.$productInfo.querySelector('#product-content');
          const viewControl = this.$productInfo.querySelector('.product-sticky-form__view_control');

          // 添加状态标记
          let isExpanded = false;

          const checkContent = () => {
            productContent.style.display = 'none';
            productContent.offsetHeight;
            productContent.style.display = '';

            const contentHeight = productContent.scrollHeight;
            const maxHeight = 200;

            if (contentHeight > maxHeight) {
              view.classList.remove('hidden');
              view.classList.add('block');

              // 设置初始状态
              if (!isExpanded) {
                productContent.style.maxHeight = `${maxHeight}px`;
                productContent.style.overflow = 'hidden';
                viewControl.innerHTML = viewControl.dataset.more;
              }
              productContent.style.transition = 'max-height 0.3s ease';
              productContent.dataset.fullHeight = contentHeight;
            } else {
              view.classList.add('hidden');
              productContent.style.maxHeight = 'none';
              viewControl.innerHTML = viewControl.dataset.less;
            }
          };

          setTimeout(checkContent, 100);

          let resizeTimeout;
          window.addEventListener('resize', () => {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(checkContent, 100);
          });

          if (view) {
            view.addEventListener('click', (e) => {
              // 阻止事件冒泡
              e.stopPropagation();
              e.preventDefault();

              isExpanded = !isExpanded;
              const fullHeight = parseInt(productContent.dataset.fullHeight, 10);
              const computedStyle = window.getComputedStyle(productContent);
              // const lineHeight = parseInt(computedStyle.lineHeight, 10) || 20;
              // const maxHeight = lineHeight * 4.5;

              if (!isExpanded) {
                // 收起
                arrow.style.transform = 'rotate(45deg)';
                arrow.style.margin = '3px auto';
                productContent.style.maxHeight = '200px';
                viewControl.innerHTML = viewControl.dataset.more;
              } else {
                // 展开
                arrow.style.transform = 'rotate(-135deg)';
                arrow.style.margin = '-2px auto';
                productContent.style.maxHeight = `${fullHeight}px`;
                viewControl.innerHTML = viewControl.dataset.less;
              }
            });

            // 防止滚动事件影响展开状态
            productContent.addEventListener('touchmove', (e) => {
              e.stopPropagation();
            });

            // 添加过渡结束事件监听
            productContent.addEventListener('transitionend', () => {
              if (isExpanded) {
                // 如果是展开状态，移除最大高度限制
                productContent.style.maxHeight = 'none';
              }
            });
          }
        }
        // 左侧缩略图
        galleryThumbs() {
          this.$galleryThumbsSwiper = new Swiper(this.$myThumbs, {
            spaceBetween: 15,
            slidesPerView: 'auto',
            lazy: {
              loadPrevNext: true, // 预加载前后两张图片
            },
            preloadImages: false,
            lazy: {
              loadPrevNext: true,
              loadPrevNextAmount: 1,
              loadOnTransitionStart: true,
            },
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            direction: 'vertical',
          });

          const thumbsSlides = this.$myThumbs.querySelectorAll('.thumbs-item');

          // 用来标记是否是手动点击触发的切换
          this.isManualSlide = false;

          thumbsSlides.forEach((slide, index) => {
            slide.addEventListener('click', () => {
              this.isManualSlide = true; // 标记为手动切换
              thumbsSlides.forEach((s) => s.classList.remove('thumbs-item-active')); // 移除所有缩略图的高亮边框
              slide.classList.add('thumbs-item-active'); // 高亮当前点击的缩略图
              this.$galleryMainSwiper.slideTo(index); // 切换到对应的主轮播图
            });
          });

          // 缩略图视频逻辑

          this.$galleryVideoThumbsSwiper = new Swiper(this.$myThumbsVideo, {
            spaceBetween: 15,
            slidesPerView: 'auto',
            lazy: {
              loadPrevNext: true, // 预加载前后两张图片
            },
            preloadImages: false,
            lazy: {
              loadPrevNext: true,
              loadPrevNextAmount: 1,
              loadOnTransitionStart: true,
            },
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            direction: 'vertical',
          });

          const videoThumbsSlides = this.$myThumbsVideo.querySelectorAll('.thumbs-item');

          // 用来标记是否是手动点击触发的切换
          this.isManualSlide = false;

          videoThumbsSlides.forEach((slide, index) => {
            slide.addEventListener('click', () => {
              this.isManualSlide = true; // 标记为手动切换
              videoThumbsSlides.forEach((s) => s.classList.remove('thumbs-item-active')); // 移除所有缩略图的高亮边框
              slide.classList.add('thumbs-item-active'); // 高亮当前点击的缩略图
              this.$galleryVideoMainSwiper.slideTo(index); // 切换到对应的主轮播图
            });
          });

          // package 缩略图

          this.$galleryPackageThumbsSwiper = new Swiper(this.$myThumbsPackage, {
            spaceBetween: 15,
            slidesPerView: 'auto',
            lazy: {
              loadPrevNext: true, // 预加载前后两张图片
            },
            preloadImages: false,
            lazy: {
              loadPrevNext: true,
              loadPrevNextAmount: 1,
              loadOnTransitionStart: true,
            },
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            direction: 'vertical',
          });

          const thumbsPackageSlides = this.$myThumbsPackage.querySelectorAll('.thumbs-item');

          // 用来标记是否是手动点击触发的切换
          this.isManualSlide = false;

          thumbsPackageSlides.forEach((slide, index) => {
            slide.addEventListener('click', () => {
              this.isManualSlide = true; // 标记为手动切换
              thumbsPackageSlides.forEach((s) => s.classList.remove('thumbs-item-active')); // 移除所有缩略图的高亮边框
              slide.classList.add('thumbs-item-active'); // 高亮当前点击的缩略图
              this.$galleryPackageMainSwiper.slideTo(index); // 切换到对应的主轮播图
            });
          });
        }

        // 轮播主图
        mainGallery() {
          // 初始化主图 Swiper
          this.$galleryMainSwiper = new Swiper(this.$myGallery, {
            spaceBetween: 10,
            pagination: {
              el: '.swiper-pagination',
            },
            loop: true,

            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
            thumbs: {
              swiper: this.$galleryThumbsSwiper,
              autoScrollOffset: 1,
              multipleActiveThumbs: false,
            },
            preloadImages: false,
            lazy: {
              loadPrevNext: true,
              loadPrevNextAmount: 1,
              loadOnTransitionStart: true,
            },
            simulateTouch: true, // 允许触摸滑动
            touchRatio: 0.6, // 拖动灵敏度
            speed: 600, // 动画时长（核心）
            effect: 'slide', // 明确启用滑动动画

            on: {
              init: (swiper) => {
                this.currentIndex = 0;
                this.updateCounter(swiper.realIndex + 1, swiper.slides.length, '.image-index-container');
              },
              slideChange: (swiper) => {
                this.updateCounter(swiper.realIndex + 1, swiper.slides.length, '.image-index-container');
              },
            },
          });

          // 找到 function-list 区域并添加事件监听
          const functionList = this.querySelectorAll('.function-list');
          console.log('functionLis2t', functionList);
          if (functionList) {
            functionList.forEach((item) => {
              item.addEventListener('click', (e) => {
                // 阻止事件冒泡
                e.stopPropagation();
              });
            });
          }

          // 修改点击事件，只在点击图片时触发预览
          this.$myGallery.addEventListener('click', (e) => {
            const clickedImage = e.target.closest('.swiper-slide img');
            const isNavigationClick = e.target.closest('.swiper-button-next, .swiper-button-prev, .swiper-pagination');

            if (clickedImage && !isNavigationClick) {
              const imageZoom = document.querySelector('product-image-zoom');
              if (!imageZoom) return;

              // 设置为非 package 模式
              imageZoom.setMode(false);

              // 设置图片数据并打开预览
              imageZoom.setImages(this.imagesArray);
              const currentIndex = this.$galleryMainSwiper.realIndex;
              imageZoom.openPreview(currentIndex);
            }
          });

          // slideChange 事件处理
          this.$galleryMainSwiper.on('slideChange', () => {
            const newIndex = this.$galleryMainSwiper.realIndex;
            this.currentIndex = newIndex;

            const thumbsSlides = this.$myThumbs.querySelectorAll('.thumbs-item');
            thumbsSlides.forEach((s) => s.classList.remove('thumbs-item-active'));

            if (thumbsSlides[newIndex]) {
              const currentThumb = thumbsSlides[newIndex];
              currentThumb.classList.add('thumbs-item-active');

              currentThumb.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',
              });

              if (this.$galleryThumbsSwiper.activeIndex !== newIndex) {
                this.$galleryThumbsSwiper.slideTo(newIndex, 0, false);
              }
            }
          });
        }
        updateCounter(current, total, container) {
          const paginationElement = this.querySelector(container);
          if (paginationElement) {
            paginationElement.textContent = `${current} / ${total}`;
          }
        }
        mainGalleryVideo() {
          // 处理视频逻辑
          this.$galleryVideoMainSwiper = new Swiper(this.$myGalleryVideo, {
            spaceBetween: 10,
            pagination: {
              el: '.swiper-pagination',
            },
            loop: true,
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
            preloadImages: false,
            lazy: {
              loadPrevNext: true,
              loadPrevNextAmount: 1,
              loadOnTransitionStart: true,
            },
            simulateTouch: true, // 允许触摸滑动
            touchRatio: 0.6, // 拖动灵敏度
            speed: 600, // 动画时长（核心）
            effect: 'slide', // 明确启用滑动动画
            thumbs: {
              swiper: this.$galleryVideoThumbsSwiper,
            },
            simulateTouch: false, // 禁用鼠标或触摸拖拽切换
            on: {
              init: (swiper) => {
                this.currentIndex = 0;
                this.updateCounter(swiper.realIndex + 1, swiper.slides.length, '.video-index-container');
              },
              slideChange: (swiper) => {
                this.updateCounter(swiper.realIndex + 1, swiper.slides.length, '.video-index-container');
              },
            },
          });
          // 同步主轮播图切换事件到缩略图
          this.$galleryVideoMainSwiper.on('slideChange', () => {
            if (this.isManualSlide) {
              this.isManualSlide = false; // 重置手动切换标志，避免干扰 slideChange 事件
              return; // 如果是手动切换，跳过这个逻辑
            }

            const activeIndex = this.$galleryVideoMainSwiper.realIndex; // 获取当前实际索引

            const thumbsSlides = this.$myThumbsVideo.querySelectorAll('.thumbs-item');

            // 移除所有缩略图的高亮边框
            thumbsSlides.forEach((s) => s.classList.remove('thumbs-item-active'));

            // 高亮当前对应的缩略图
            if (thumbsSlides[activeIndex]) {
              thumbsSlides[activeIndex].classList.add('thumbs-item-active');

              // 获取缩略图容器和当前缩略图
              const thumbContainer = this.$myThumbsVideo.querySelector('.swiper-wrapper');
              const currentThumb = thumbsSlides[activeIndex];

              // 获取当前缩略图的位置和容器的尺寸
              const currentThumbRect = currentThumb.getBoundingClientRect();
              const thumbContainerRect = thumbContainer.getBoundingClientRect();

              // 如果当前处于第一张，需要重置缩略图容器的 translate3d 偏移
              if (activeIndex === 0) {
                thumbContainer.style.transform = 'translate3d(0px, 0px, 0px)';
              } else {
                // 计算当前缩略图的偏移量，居中显示
                const offset =
                  currentThumb.offsetTop - (thumbContainer.offsetHeight / 2 - currentThumb.offsetHeight / 2);

                // 确保容器内的缩略图在可见区域内
                if (
                  currentThumbRect.top < thumbContainerRect.top || // 当前缩略图在容器顶部上方
                  currentThumbRect.bottom > thumbContainerRect.bottom // 当前缩略图在容器底部下方
                ) {
                  thumbContainer.style.transform = `translate3d(0px, -${offset}px, 0px)`; // 使用 transform 来滚动
                }

                // 处理最后几个缩略图始终处于底部的情况
                const maxOffset = thumbContainer.scrollHeight - thumbContainer.offsetHeight;
                const finalOffset = Math.min(offset, maxOffset); // 确保不会超出容器范围
                thumbContainer.style.transform = `translate3d(0px, -${finalOffset}px, 0px)`; // 修正偏移
              }
            }
          });
        }
        // 轮播Package主图
        mainGalleryPackage() {
          // 检查必要的元素是否存在
          if (!this.$myGalleryPackage || !this.$galleryPackageThumbsSwiper) {
            console.log('Required elements for package gallery not found');
            return;
          }

          // 检查是否有幻灯片
          const slides = this.$myGalleryPackage.querySelectorAll('.swiper-slide');
          if (!slides || slides.length === 0) {
            console.log('No slides found for package gallery');
            return;
          }

          try {
            // 初始化 package 主图 Swiper
            this.$galleryPackageMainSwiper = new Swiper(this.$myGalleryPackage, {
              spaceBetween: 10,
              pagination: {
                el: '.swiper-pagination',
              },
              loop: slides.length > 1, // 只有多于一张图片时才启用循环
              navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
                enabled: slides.length > 1, // 只有多于一张图片时才启用导航
              },
              preloadImages: false,
              simulateTouch: true, // 允许触摸滑动
              touchRatio: 0.6, // 拖动灵敏度
              speed: 600, // 动画时长（核心）
              effect: 'slide', // 明确启用滑动动画
              lazy: {
                loadPrevNext: true,
                loadPrevNextAmount: 1,
                loadOnTransitionStart: true,
              },
              thumbs: {
                swiper: this.$galleryPackageThumbsSwiper,
              },
              simulateTouch: false,
              on: {
                init: (swiper) => {
                  this.currentIndex = 0;
                  this.updateCounter(swiper.realIndex + 1, swiper.slides.length, '.package-index-container');
                },
                slideChange: (swiper) => {
                  this.updateCounter(swiper.realIndex + 1, swiper.slides.length, '.package-index-container');
                },
              },
            });

            // 添加点击事件，仿照 mainGallery 的处理方式
            this.$myGalleryPackage.addEventListener('click', (e) => {
              const clickedImage = e.target.closest('.swiper-slide img');
              const isNavigationClick = e.target.closest(
                '.swiper-button-next, .swiper-button-prev, .swiper-pagination'
              );

              if (clickedImage && !isNavigationClick) {
                const imageZoom = document.querySelector('product-image-zoom');
                if (!imageZoom) return;

                // 首先尝试获取 package-media 数据
                const packageMedia = imageZoom.querySelector('.package-media');
                if (packageMedia && packageMedia.textContent) {
                  try {
                    const packageData = JSON.parse(packageMedia.textContent);
                    if (packageData && Object.keys(packageData).length > 0) {
                      // 设置为 package 模式
                      imageZoom.setMode(true);

                      const formattedPackageData = Object.entries(packageData).map(([index, url]) => ({
                        [`${parseInt(index) + 1}.img`]: url.startsWith('//') ? `https:${url}` : url,
                      }));
                      imageZoom.setImages(formattedPackageData);
                      const currentIndex = this.$galleryPackageMainSwiper.realIndex;
                      imageZoom.openPreview(currentIndex);
                      return;
                    }
                  } catch (error) {
                    console.error('Error parsing package media data:', error);
                  }
                }

                // 如果没有 package 数据，回退到 product 数据
                imageZoom.setMode(false); // 设置为非 package 模式
                // 如果没有 package 数据或解析失败，回退到使用 product-media 数据
                const productMedia = imageZoom.querySelector('.product-media');
                if (!productMedia) return;

                try {
                  const productData = JSON.parse(productMedia.textContent);
                  const formattedProductData = productData
                    .filter((media) => media.media_type === 'image')
                    .map((media, index) => ({
                      [`${index + 1}.img`]: media.preview_image.src,
                    }));

                  if (formattedProductData.length > 0) {
                    imageZoom.setImages(formattedProductData);
                    const currentIndex = this.$galleryPackageMainSwiper.realIndex;
                    imageZoom.openPreview(currentIndex);
                  }
                } catch (error) {
                  console.error('Error parsing product media data:', error);
                }
              }
            });

            // 同步主轮播图切换事件到缩略图
            this.$galleryPackageMainSwiper.on('slideChange', () => {
              if (this.isManualSlide) {
                this.isManualSlide = false;
                return;
              }

              const activeIndex = this.$galleryPackageMainSwiper.realIndex;
              const thumbsSlides = this.$myThumbsPackage.querySelectorAll('.thumbs-item');

              // 移除所有缩略图的高亮边框
              thumbsSlides.forEach((s) => s.classList.remove('thumbs-item-active'));

              // 高亮当前对应的缩略图
              if (thumbsSlides[activeIndex]) {
                thumbsSlides[activeIndex].classList.add('thumbs-item-active');

                // 获取缩略图容器和当前缩略图
                const thumbContainer = this.$myThumbsPackage.querySelector('.swiper-wrapper');
                const currentThumb = thumbsSlides[activeIndex];

                // 处理缩略图滚动位置
                if (thumbContainer && currentThumb) {
                  // 如果是第一张，重置位置
                  if (activeIndex === 0) {
                    thumbContainer.style.transform = 'translate3d(0px, 0px, 0px)';
                  } else {
                    const offset =
                      currentThumb.offsetTop - (thumbContainer.offsetHeight / 2 - currentThumb.offsetHeight / 2);
                    const maxOffset = thumbContainer.scrollHeight - thumbContainer.offsetHeight;
                    const finalOffset = Math.min(offset, maxOffset);
                    thumbContainer.style.transform = `translate3d(0px, -${finalOffset}px, 0px)`;
                  }
                }
              }
            });
          } catch (error) {
            console.error('Error initializing package gallery:', error);
          }
        }

        changeGallery() {
          const productTabsContainer = this.querySelector('.product-tabs-container');
          const tabs = productTabsContainer.querySelectorAll('.product-tabs-item');

          tabs.forEach((tab) => {
            tab.addEventListener('click', () => {
              // 移除所有选项的 active 类
              tabs.forEach((t) => t.classList.remove('active'));
              // 为当前点击的选项添加 active 类
              tab.classList.add('active');
              // 获取对应的内容区域标识 (可选，用于加载对应内容)
              const tabContent = tab.dataset.tab;

              if (tabContent == 'features') {
                this.$thumbsImage.forEach((img) => img.classList.add('flex'));
                this.$thumbsImage.forEach((img) => img.classList.remove('hidden'));
                this.$thumbsVideo.forEach((video) => video.classList.add('hidden'));
                this.$thumbsVideo.forEach((video) => video.classList.remove('flex'));
                this.$thumbsPackage.forEach((packages) => packages.classList.add('hidden'));
                this.$thumbsPackage.forEach((packages) => packages.classList.remove('flex'));
              } else if (tabContent == 'videos') {
                this.$thumbsImage.forEach((img) => img.classList.add('hidden'));
                this.$thumbsImage.forEach((img) => img.classList.remove('flex'));
                this.$thumbsPackage.forEach((packages) => packages.classList.add('hidden'));
                this.$thumbsPackage.forEach((packages) => packages.classList.remove('flex'));
                this.$thumbsVideo.forEach((video) => video.classList.add('flex'));
                this.$thumbsVideo.forEach((video) => video.classList.remove('hidden'));
              } else if (tabContent == 'package') {
                this.$thumbsImage.forEach((img) => img.classList.add('hidden'));
                this.$thumbsImage.forEach((img) => img.classList.remove('flex'));
                this.$thumbsPackage.forEach((packages) => packages.classList.add('flex'));
                this.$thumbsPackage.forEach((packages) => packages.classList.remove('hidden'));
                this.$thumbsVideo.forEach((video) => video.classList.add('hidden'));
                this.$thumbsVideo.forEach((video) => video.classList.remove('flex'));
              }
            });
          });
        }

        // 修改 getImagesArray 方法，添加更多错误处理和日志
        getImagesArray() {
          if (!this.$productMedia) {
            console.warn('productMedia element not found');
            return [];
          }

          try {
            const mediaJson = JSON.parse(this.$productMedia.textContent || this.$productMedia.innerHTML);

            if (!Array.isArray(mediaJson)) {
              console.warn('mediaJson is not an array:', mediaJson);
              return [];
            }

            const formattedImages = mediaJson
              .filter((media) => {
                if (!media || !media.media_type) {
                  console.warn('Invalid media item:', media);
                  return false;
                }
                return media.media_type === 'image';
              })
              .map((media, index) => {
                if (!media.preview_image || !media.preview_image.src) {
                  console.warn('Invalid preview image:', media);
                  return null;
                }
                return {
                  [`${index + 1}.img`]: media.preview_image.src,
                };
              })
              .filter(Boolean); // 移除任何 null 值

            return formattedImages;
          } catch (error) {
            console.error('Error parsing media JSON:', error);
            return [];
          }
        }

        // 添加获取 package 图片数组的方法
        getPackageImagesArray() {
          const packageMedia = document.querySelector('product-image-zoom')?.querySelector('.package-media');
          if (!packageMedia) return [];

          try {
            const packageData = JSON.parse(packageMedia.textContent);
            return Object.entries(packageData).map(([index, url]) => ({
              [`${parseInt(index) + 1}.img`]: url.startsWith('//') ? `https:${url}` : url,
            }));
          } catch (error) {
            console.error('Error parsing package media JSON:', error);
            return [];
          }
        }
      }
    );
  }
});
